import React, { useState } from 'react';
import styles from './CreateRoom.module.css';

interface CreateRoomProps {
  onBack: () => void;
  onCreate: (settings: any) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const CreateRoom: React.FC<CreateRoomProps> = ({ 
  onBack, 
  onCreate, 
  loading, 
  error 
}) => {
  const [timeControl, setTimeControl] = useState({
    type: 'blitz',
    initial: 5 * 60 * 1000, // 5 minutes
    increment: 0,
  });
  
  const handleCreate = () => {
    onCreate({
      timeControl,
      spectatingAllowed: false,
      rated: false,
    });
  };
  
  const timePresets = [
    { label: 'Bullet 1+0', type: 'bullet', initial: 1 * 60 * 1000, increment: 0 },
    { label: 'Blitz 3+0', type: 'blitz', initial: 3 * 60 * 1000, increment: 0 },
    { label: 'Blitz 5+0', type: 'blitz', initial: 5 * 60 * 1000, increment: 0 },
    { label: 'Rapid 10+0', type: 'rapid', initial: 10 * 60 * 1000, increment: 0 },
    { label: 'Rapid 15+10', type: 'rapid', initial: 15 * 60 * 1000, increment: 10000 },
  ];
  
  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <h3 className={styles.title}>Create New Room</h3>
        
        <div className={styles.section}>
          <label className={styles.label}>Time Control</label>
          <div className={styles.presets}>
            {timePresets.map((preset) => (
              <button
                key={preset.label}
                onClick={() => setTimeControl(preset)}
                className={`${styles.preset} ${
                  timeControl.initial === preset.initial && 
                  timeControl.increment === preset.increment 
                    ? styles.active 
                    : ''
                }`}
              >
                {preset.label}
              </button>
            ))}
          </div>
        </div>
        
        <div className={styles.actions}>
          <button 
            onClick={onBack} 
            className={`${styles.button} ${styles.secondaryButton}`}
            disabled={loading}
          >
            Back
          </button>
          <button 
            onClick={handleCreate} 
            className={`${styles.button} ${styles.primaryButton}`}
            disabled={loading}
          >
            {loading ? 'Creating...' : 'Create Room'}
          </button>
        </div>
        
        {error && <p className={styles.error}>{error}</p>}
      </div>
    </div>
  );
};